export const REDUCER_KEY = 'clientManagers';
